const backendUrl = "https://mern-profile-store-server.onrender.com";

export default backendUrl;
